
export const GET_BRAND_VISIBILITY_SUCCESS = 'GET_BRAND_VISIBILITY_SUCCESS';
export const GET_BRAND_VISIBILITY_FAILURE = 'GET_BRAND_VISIBILITY_FAILURE';

export const POST_BRAND_VISIBILITY_SUCCESS = 'POST_BRAND_VISIBILITY_SUCCESS';
export const POST_BRAND_VISIBILITY_FAILURE = 'POST_BRAND_VISIBILITY_FAILURE';
